import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const ReportFieldInput = () => {
  const { fieldId = '' } = useParams();
  const decodedId = fieldId ? atob(fieldId) : fieldId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'reportField';

  useEffect(() => {
    if (fieldId) { setIsEditing(true); fetchDetails(); }
  }, [fieldId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['reportField'] + id + '/', { headers });
      const d = response.data;
      setFormData({
        ...d,
        report: d.report?.id ?? d.report,
      });
    } catch (error) { console.error('Error fetching Report Field details:', error); }
  };

  const fields = [
    {
      name: 'report',
      label: 'Report',
      type: 'async-select',
      required: true,
      endpoint: API_ROUTES.report,
      getOptionLabel: (r) => r.name,
    },
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'data_type', label: 'Data Type', type: 'text', required: true } // Mapped to 'data_type'
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Report Field' : 'Create Report Field'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/report-field/list" />
    </div>
  );
};

export default ReportFieldInput;